module.exports = __webpack_public_path__ + "img/110.82ba395c.jpg";